export const encryptData = (data) => {
  // Encryption
  return window.btoa(data);
};

export const decryptData = (str) => {
  // Decryption
  return window.atob(str);
};
